// Save login data
export const saveAuthData = (user, token) => {
  const expiryTime = new Date().getTime() + 2 * 60 * 60 * 1000; // 2 hours in ms

  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('token', token);
  localStorage.setItem('tokenExpiry', expiryTime.toString());
};

// Check if user is logged in and not expired
export const isUserLoggedIn = () => {
  const token = localStorage.getItem('token');
  const expiry = localStorage.getItem('tokenExpiry');

  if (!token || !expiry) return false;

  const now = new Date().getTime();
  return now < parseInt(expiry);
};

// Get logged-in user data
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Clear login data (for logout)
export const clearAuthData = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiry');
};
